import { monthNamesRu } from '@app/utils/quarters';

type HashrateItem = {
  date: string;
  hashrate: number;
};

const parseDate = (date: string): Date => {
  const [day, month, year] = date.split('-').map(Number);
  return new Date(year, month - 1, day);
};

function groupByIndex(data: Array<HashrateItem>, size: number, getIndex: (date: Date) => number) {
  const map = new Array<{ date: Date; hashrate: number } | null>(size).fill(null);

  for (const item of data) {
    const date = parseDate(item.date);
    const index = getIndex(date);

    const current = map[index];
    if (!current || date > current.date) {
      map[index] = { date, hashrate: item.hashrate };
    }
  }

  return map.map(value => value?.hashrate ?? 0);
}

export const groupByMonths = (data: Array<HashrateItem>) => {
  const values = groupByIndex(data, 12, date => date.getMonth());

  return monthNamesRu.map((name, index) => ({
    name,
    value: values[index],
  }));
};

const quartes = ['Q1', 'Q2', 'Q3', 'Q4'];

export const groupByQuarters = (data: Array<HashrateItem>) => {
  const values = groupByIndex(data, 4, date => Math.floor(date.getMonth() / 3));

  return quartes.map((name, index) => ({
    name,
    value: values[index],
  }));
};
